jQuery(document).ready(function($){
    if ( $('.nf-testimonial-slider-block') ) {
        $('.nf-testimonial-slider-block .nf-testimonial-slider-block__slider').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: '<button class="nextbtn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13.6923 17.3079L12.9845 16.5886L17.073 12.5001H5V11.5001H17.073L12.9845 7.41163L13.6923 6.69238L19 12.0001L13.6923 17.3079Z" fill="white"/></svg></button>',
            appendArrows: $('.nf-testimonial-slider-block__nav'),
            dots: false,
        });
    }
    if ( $('.nf-workshops__sessions') ) {
        $('.nf-workshops__sessions .nf-workshops__sessions-slider').slick({
            slidesToScroll: 1,
            slidesToShow: 2,
            prevArrow: '',
            nextArrow: '<button class="nextbtn"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M14.0264 17.3079L13.3195 16.5886L17.4033 12.5001H5.34424V11.5001H17.4033L13.3195 7.41163L14.0264 6.69238L19.3281 12.0001L14.0264 17.3079Z" fill="#146898"/></svg></button>',
            appendArrows: $('.nf-workshops__sessions-slider__nav'),
            dots: false,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        fade: true,
                        arrows: false,
                    }
                }
            ]
        });
    }

    if ( $('.nf-book-packages__slider') ) {
        $('.nf-book-packages__slider').slick({
            slidesToScroll: 1,
            slidesToShow: 2,
            prevArrow: '',
            nextArrow: '<button class="nextbtn"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M14.0264 17.3079L13.3195 16.5886L17.4033 12.5001H5.34424V11.5001H17.4033L13.3195 7.41163L14.0264 6.69238L19.3281 12.0001L14.0264 17.3079Z" fill="#146898"/></svg></button>',
            appendArrows: $('.nf-book-packages__slider-nav'),
            dots: false,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        fade: true,
                        arrows: false,
                    }
                }
            ]
        });
    }
});